import { Toast } from '@base-ui/react/toast'
import styled from 'styled-components'

import { zIndex } from '@styles/tokens'

export const Viewport = styled(Toast.Viewport)`
  outline: none;
`

export const Positioner = styled(Toast.Positioner)`
  z-index: ${zIndex.tooltip};
`

export const Card = styled(Toast.Root)`
  border-radius: 5px;
  border: 1px solid var(--Border-Neutral-faded, #dfe2ea);
  background: var(--background-neutral, #dfe2ea);
  padding: 4px 8px;
  color: var(--Text-Primary, #14171f);
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
  outline: none;
  transition: opacity 0.3s;

  &[data-starting-style],
  &[data-ending-style] {
    opacity: 0;
  }
`

export const Description = styled(Toast.Description)`
  margin: 0;
`
